import React from 'react';
import { IProps as IBlockProps } from './AccreditationBlock.interface';
import { AccreditationBlock } from './AccreditationBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

interface IBlockInputProps {
    heading: string;
    description: string;
    items: Array<{
        image: any;
        heading: string;
        description: string;
    }>;
    cardType: 'horizontal' | 'vertical';
    background: ThemeColors;
    [key: string]: any;
}

const mapInputToProps = (
    input: IBlockInputProps
): IBlockProps => {
    const { heading, description, items, cardType, background, ...rest } = input;

    return {
        heading: heading,
        description: description,
        cards: items.map((item) => ({
            image: item.image ? translation.mapImageProps(item.image) : undefined,
            heading: item.heading,
            description: item.description,
        })),
        cardType: cardType || 'vertical',
        backgroundColor: background || 'white',
        ...rest,
    }
};

const BlockTranslation: React.FC<IBlockInputProps> = (
    inputProps
) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={AccreditationBlock}
        mapProps={mapInputToProps}
    />
);

export default BlockTranslation;